import LinkOutlined from "@mui/icons-material/LinkOutlined";
import { IconButton, Tooltip, type IconButtonProps, type SvgIconProps } from "@mui/material";

export function ScoutDeepLinkCopyButton({
  ariaLabel,
  tooltip,
  onClick,
  className,
  size = "small",
  sx,
  iconFontSize = "inherit",
}: {
  ariaLabel: string;
  tooltip: string;
  onClick: IconButtonProps["onClick"];
  className?: string;
  size?: IconButtonProps["size"];
  sx?: IconButtonProps["sx"];
  iconFontSize?: SvgIconProps["fontSize"];
}) {
  return (
    <Tooltip title={tooltip}>
      <IconButton
        aria-label={ariaLabel}
        className={className}
        onClick={onClick}
        size={size}
        sx={sx}
      >
        <LinkOutlined fontSize={iconFontSize} />
      </IconButton>
    </Tooltip>
  );
}
